import { render, staticRenderFns } from "./ThePlayer.vue?vue&type=template&id=da5ed190&scoped=true&"
import script from "./ThePlayer.vue?vue&type=script&lang=js&"
export * from "./ThePlayer.vue?vue&type=script&lang=js&"
import style0 from "./ThePlayer.vue?vue&type=style&index=0&id=da5ed190&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5ed190",
  null
  
)

export default component.exports